import { render, staticRenderFns } from "./NewVersionReleased.vue?vue&type=template&id=4913f190"
import script from "./NewVersionReleased.vue?vue&type=script&lang=js"
export * from "./NewVersionReleased.vue?vue&type=script&lang=js"
import style0 from "./NewVersionReleased.vue?vue&type=style&index=0&id=4913f190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports